export default "__VITE_ASSET__3rb4Ftse__ 376w";